function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 .5a.5.5 0 01.492.41L7.5 1v5.5H13a.5.5 0 01.09.992L13 7.5H7.5V13a.5.5 0 01-.992.09L6.5 13V7.5H1a.5.5 0 01-.09-.992L1 6.5h5.5V1A.5.5 0 017 .5z",
  fill: "#2AB770",
  fillRule: "nonzero"
})));